import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import TFObject from '../../components/TFObject';
import TFSkeleton from '../../components/Skeleton';

const User = ( { meta, users, setCurrent } ) => {
    let params = useParams();
    const [ loaded, setLoaded ] = useState( false );
    const [ u, setUser ] = useState( { 
        details: {}
    } );
    
    useEffect( () => {
        if ( params.uid ) {
            setCurrent( { email: params.uid } );

            if ( users[params.uid] ) {
                setUser( { 
                    details: users[params.uid]
                } );
                setLoaded( true );
            }
        }
    }, [ params.uid, users, setCurrent ] );

    useEffect( () => {
        document.title = `Third Floor - ${u?.details?.name}`;
    }, [ u ] );

    return (
        loaded ? (
            <TFObject key={params.cid} objType='user' obj={u} oid={params.uid} objPick={meta.picklist} header={meta.header} details={meta.details} sidebar={meta.sidebar} />
        ) : (
            <TFSkeleton />
        )
    );
}

const mapProps = ( state ) => ( {
    meta: state.user.meta.user,
    users: state.admin.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
    setCurrent: dispatch.admin.setCurrent
} );
  
export default connect( mapProps, mapDispatch )( User );